/**
 * LMI
 */
var _hash=window.location.hash;
jQuery(document).ready(function ($) {
    if($('.filters').length) {
        // When the user scrolls the page, execute myFunction
        window.onscroll = function () {
            myFunction()
        };

        // Get the header
        var $header = $('.filters');

        // Get the offset position of the navbar
        var sticky = $header.offset().top;

        // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
        function myFunction() {
            if (window.pageYOffset > sticky) {
                $header.addClass("sticky");
            } else {
                $header.removeClass("sticky");
            }
        }

        if (_hash === '#onpath') {
            setTimeout(function () {
                window.scrollTo(0, sticky);
            }, 300);
        }
    }
  $(document).on("click", ".lmi-list .update-fav-career", function (e) {
    e.preventDefault();
    var $fav = $(this);
    //$fav.addClass('fa-spin');
    addWaiting();
    var call = $(this).data("get");
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: { action: 'fw_fakeUpdateFavCareer', CareerID: $(this).data("for") },
      dataType: "json",
      success: function (data) {
        $("#waiting").remove();
        console.log(data[0]);
        if (data[0] == "success") {
          if ($fav.hasClass("fa-heart-o")) {
            $fav.removeClass("fa-heart-o").addClass("fa-heart");
          } else {
            $fav.removeClass("fa-heart").addClass("fa-heart-o");
          }
          $fav.removeClass("fa-spin");
        }
      },
      error: function (xhr, desc, err) {
        console.log(xhr);
        console.log("Details0: " + desc + "\nError:" + err);
      },
    });
  });
  $(".lmi-10 .filters select, .career-outlook .filters input, .looking-ahead .filters input").on("change", function () {
    var action = "fw_lmi_top_10_lists";
    if ($(".secondary.lmi-10").hasClass("career-outlook") || $(".secondary.lmi-10").hasClass("looking-ahead")) {
      action = "fw_lmi_career_outlook";
      if ($(this).attr("id") != "StartRow") {
        $("#StartRow").val("");
      }
    }
    addWaiting();
    $.ajax({
      type: "POST",
      url:"/wp-admin/admin-ajax.php",
      data: 'action='+action+'&'+$(".filters select, .filters input").serialize(),
      dataType: "html",
      success: function (data) {
        $(".list-boxes").html(data);
        if ($(".lmi-list__bubble").length) {
          setTimeout(showBubbles, 300);
        }
        $("#waiting").remove();
      },
      error: function (xhr, desc, err) {
        console.log(xhr);
        console.log("Details0: " + desc + "\nError:" + err);
      },
    });
  });
  $(document).on("change", ".lmi-heat-map select, .lmi-heat-map input", function () {
    var action = "fw_lmi_heat_map";
    if ($(this).attr("id") == "category") {
      $("#occupation").val("");
    }
    $("#nk").val($("#category option:selected").data("nk"));
    $("#cluster").val($("#category option:selected").text());
    addWaiting();
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: 'action='+action+'&'+$(".filters select, .filters input").serialize(),
      dataType: "html",
      success: function (data) {
        $("#popular_places").html(data);
        $("#popular_places select").select2();

        fwLabelLmiSelect2($(
          "#popular-places-category-label, #popular-places-occupation-label"
        ));

        $("#waiting").remove();
      },
      error: function (xhr, desc, err) {
        console.log(xhr);
        console.log("Details0: " + desc + "\nError:" + err);
      },
    });
  });
  $(".career-card__tab-nav a.tab-nav").on("click", function (e) {
    e.preventDefault();
    $(this).closest(".career-card__tab-nav").find("a.tab-nav").removeClass("selected");
    $(this).addClass("selected");
    var _for = $(this).data("for");
    var _fors = [];
    if (_for.indexOf(", ") > -1) {
      _fors = _for.split(", ");
    } else {
      _fors = [_for];
    }
    for (var k in _fors) {
      var _f = _fors[k];
      $("[name=" + _f + "] .career-card__tab").removeClass("selected");
      $("[name=" + _f + "]")
        .find("[name=" + $(this).data("tab") + "]")
        .addClass("selected");
    }
  });

  $(document).on("click", ".save-career, .remove-career", function (e) {
    e.preventDefault();
    var $svbtn = $(this);
    if ($svbtn.hasClass("disabled")) return;
    $svbtn.css("opacity", 0.5).addClass("disabled");
    var elements;
    if ($svbtn.hasClass("remove-career")) {
        elements = { action: 'fw_fakeSaveCareer', CareerID: $(this).attr("id"), remove: true };
    } else {
        elements = { action: 'fw_fakeSaveCareer', CareerID: $(this).attr("id") };
    }
    //console.log('here');
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: elements, // serializes the form's elements.
      dataType: "json",
      success: function (data) {
        if (data[0] === "success") {
          if ($svbtn.hasClass("save-career")) {
            $svbtn.removeClass("save-career").removeClass("primary").addClass("remove-career").addClass("secondary").text("REMOVE THIS CAREER");
          } else {
            $svbtn.removeClass("remove-career").removeClass("secondary").addClass("save-career").addClass("primary").text("SAVE THIS CAREER");
          }
          $svbtn.css("opacity", 1).removeClass("disabled");
        } else if (data.errors.length > 0) {
          for (var i = 0; i < data.errors.length; i++) {
            $cur.children(".errors").append('<p class="error">' + data.errors[i] + "</p>");
          }
        } else {
          $cur.children(".errors").append('<p class="error">' + data + "</p>");
        }
      },
      error: function () {},
    });
  });

  $(document).on("click", ".missing-content", function (e) {
    e.preventDefault();
    addOverlay("missing-content-ol", "<h3>This feature is coming soon! Stay tuned…</h3>");
  });

  $(".video-embed").on("click", function (e) {
    e.preventDefault();
    var maxHeight = $(window).height() * 0.8;
    var maxWidth = $(window).width() * 0.8;
    var width = maxWidth;
    var height = width / (16 / 9);
    if (height > maxHeight) {
      height = maxHeight;
      width = height * (16 / 9);
    }
    height += 15;
    addOverlay("video-overlay", '<div class="videoWrapper"><iframe id="vidFrame" src="' + $(this).data("url") + '" frameborder="0" scrolling="no" style="width:' + width + "px; height:" + height + 'px;" allowfullscreen/></div>');

    var resizeVideoTimer;
    $(window).on("resize", function (e) {
      clearTimeout(resizeVideoTimer);
      resizeVideoTimer = setTimeout(function () {
        var maxHeight = $(window).height() * 0.8;
        var maxWidth = $(window).width() * 0.8;
        var width = maxWidth;
        var height = width / (16 / 9);
        if (height > maxHeight) {
          height = maxHeight;
          width = height * (16 / 9);
        }
        height += 15;
        $("#vidFrame").css({ width: width + "px", height: height + "px" });
      }, 250);
    });
  });
  $(document).on("click", ".lmi-list__nav a", function (e) {
    e.preventDefault();
    $("#StartRow").val($(this).data("startRow")).change();
  });

  $(document).on("click", ".lmi-heat-map path,.lmi-heat-map circle", function (e) {
    var path = false;
    var $occupation = $('[name="occupation"]');
    var $category = $('[name="category"]');
    var vals = {};
    vals["state"] = $(this).attr("id");
    if (vals["state"] == "DC2") vals["state"] = "DC";
    if ($occupation.val() != "") {
      vals["CareerID"] = $occupation.val();
      vals['action']='fw_career_card_heatmap_ajax';
      path=true;
    } else if ($category.val() != "") {
      vals["CategoryID"] = $category.val();
      vals['action']='fw_list_card_heatmap_ajax';
      path=true;
    }
    if (!path) return false;
    e.preventDefault();
    addWaiting();
    $.ajax({
      type: "POST",
      url: '/wp-admin/admin-ajax.php',
      data: vals,
      dataType: "html",
      success: function (data) {
        addOverlay("heat-map", data);
        $("#waiting").remove();
      },
      error: function (xhr, desc, err) {
        console.log(xhr);
        console.log("Details0: " + desc + "\nError:" + err);
      },
    });
  });

  if ($(".lmi-list__bubble").length) {
    showBubbles();
  }

  function showBubbles() {
      var ttw = 300;
      $(".lmi-list__bubble").each(function () {
          var $this = $(this);
          textFit($this.children(".lmi-list__bubble-wrap"), {reProcess: false});
          setTimeout(function () {
              $this.addClass("visible");
          }, ttw);
          ttw += 100;
      });
      $(".lmi-list__bubble").hover(
          function () {
              $(".lmi-list__bubble").removeClass("faded zoomed active").addClass("faded");
              var id = $(this).data("for");
              $("#demand_" + id + ", #growth_" + id)
                  .removeClass("faded")
                  .addClass("zoomed");
          },
          function () {
              if (!$(this).hasClass("active")) $(".lmi-list__bubble").removeClass("faded zoomed");
          }
      );
      $(".lmi-list__bubble").on("click", function (e) {
          if (!$(this).hasClass("zoomed")) {
              $(".lmi-list__bubble").removeClass("faded zoomed active").addClass("faded");
              var id = $(this).data("for");
              $("#demand_" + id + ", #growth_" + id)
                  .removeClass("faded")
                  .addClass("zoomed");
              e.preventDefault();
              return false;
          } else {
              $(this).addClass("active");
              $(document).on("click", "#overlay, #olClose, .olClose", function (e) {
                  if($('#overlay').hasClass('required')) return;
                  if (e.target == this) {
                      $(".lmi-list__bubble").removeClass("faded zoomed");
                  }
              });
          }
      });
  }
    $(document).on('change','.cluster-occupation-picker select',function(){
        var $form=$('.cluster-occupation-picker');
        if($(this).attr('id')=='category'){
            $('#occupation').val('');
            $('#nk').val($('#category option:selected').data('nk'));
            $('#cluster').val($('#category option:selected').text());
            addWaiting();
            $.ajax({
                type:'POST',
                url: '/wp-admin/admin-ajax.php',
                data:'action=fw_get_cluster_occupation_ajax&'+$form.serialize(),
                dataType:'html',
                success: function(data)
                {
                    $form.html(data);
                    $form.find('select').select2();
                    $('#waiting').remove();
                },
                error: function(xhr, desc, err) {
                    console.log(xhr);
                    console.log("Details0: " + desc + "\nError:" + err);
                },
            });
        }else{
            $form.find('input, select:not(#occupation)').attr('disabled','disabled');
            addWaiting();
            $form.submit();
        }
    });

    if($('#career-path-instructions').length){
        $('.cpi__nav a').on('click',function(e){
            e.preventDefault();
            var $this=$(this);
            var cur=Number($('.cpi__slide.active').attr('id').replace('slide-',''));

            if($this.hasClass('skip')){
                gotoCpi(6);
            }else if($this.hasClass('next')){
                gotoCpi(cur+1);
            }else if($this.hasClass('previous')){
                gotoCpi(cur-1);
            }else{
                gotoCpi($this.data('for'));
            }
        });
        function gotoCpi(which){
            $('.cpi__slide, .cpi-nav').removeClass('active');
            $('#slide-'+which).addClass('active');
            $('.cpi-nav[data-for="'+which+'"]').addClass('active');
            $('#slide-1').css('margin-left','-'+((which-1)*100)+'%');
            if(which > 1){
                $('.previous').removeClass('disabled');
            }else{
                $('.previous').addClass('disabled');
            }
            if(which < 6){
                $('.next').removeClass('disabled');
                $('.skip').removeClass('disabled');
            }else{
                $('.next').addClass('disabled');
                $('.skip').addClass('disabled');
            }
        }
    }
    if($('.career-path__career').length){
        var initData={'initial':true};
        addEvent(initData,'');
        setupCp();

        $('.filters__expand').on('click',function(){
            if($(this).closest('.filters__filter').hasClass('disabled')) return;
            $('.filters').toggleClass('expanded');
            if($('.filters').hasClass('expanded')){
                $('.filters__expand .filters__icon i').removeClass('fa-caret-right').addClass('fa-caret-down');
            }else{
                $('.filters__expand .filters__icon i').removeClass('fa-caret-down').addClass('fa-caret-right');
            }
        });
        $(document).on('change','.career-path__clusters select',function(){
            return;
            addWaiting();
            var val={'url':'/wp-admin/admin-ajax.php','data':{action:'fw_lmi_career_path','occupation':$('#career').data('occupation-id'),'left-cluster':$('#left-cluster :selected').val(), 'right-cluster':$('#right-cluster :selected').val()},'dataType':'html','selector':'#the-path','action':'setupCp'};
            $.ajax({
                type:'POST',
                url: val.url,
                data: val.data,
                dataType: val.dataType,
                success: function(data)
                {
                    addEvent(val,'select-cluster');
                    $('#waiting').remove();
                    $('#the-path').html(data);
                    setupCp();
                },
                error: function(xhr, desc, err) {
                    console.log(xhr);
                    console.log("Details0: " + desc + "\nError:" + err);
                },
            });
        });
        $(document).on('change','#right-cluster,#left-cluster',function(e){
           addWaiting();
           var $this=$(this);
           var $other=null;
           var side='';
           if($this.attr('id')=='right-cluster'){
               $other=$('#left-cluster');
               side='.right';
           }else{
               $other=$('#right-cluster');
               side='.left';
           }
           if($other.val()=='') side='both';
            var val={'url':'/wp-admin/admin-ajax.php','data':{action:'fw_lmi_career_path_quadrants','occupation':$('#career').data('occupation-id'),'left-cluster':$('#left-cluster :selected').val(), 'right-cluster':$('#right-cluster :selected').val(),'side':$this.attr('id')},'dataType':'html','selector':'#the-path','action':'clearClusters','side':side};
            $.ajax({
                type:'POST',
                url: '/wp-admin/admin-ajax.php',
                data: {action:'fw_lmi_career_path_quadrants','occupation':$('#career').data('occupation-id'),'left-cluster':$('#left-cluster :selected').val(), 'right-cluster':$('#right-cluster :selected').val(),'side':$this.attr('id')},
                dataType: 'html',
                success: function(data)
                {
                    $('#waiting').remove();
                    addEvent(val,'change-cluster');
                    if(side=='both'){
                        $('.career-path__career.left, .career-path__career.right,.career-path__clusters').remove();
                    }else{
                        $('.career-path__career'+side+',.career-path__clusters').remove();
                    }
                    $('#the-path').append(data);
                    setupCp(side);
                },
                error: function(xhr, desc, err) {
                    console.log(xhr);
                    console.log("Details0: " + desc + "\nError:" + err);
                },
            });
        });

        var $rc=$('#right-cluster');
        var $lc=$('#left-cluster');
        if($rc.val()!='') $rc.change();
        if($lc.val()!='') $lc.change();
        function clearClusters(side){
            if(side=='both'){
                $('.career-path__career.left, .career-path__career.right,.career-path__clusters').remove();
            }else{
                $('.career-path__career'+side+',.career-path__clusters').remove();
            }
        }
        function setupCp(side=false){
            textFit($('.career-path__label, #career .career-path__career-wrap label'),{reProcess:false, multiLine:true,maxFontSize:32, minFontSize:14});
            textFit($('.career-path__career:not(#career) .career-path__career-wrap label'),{reProcess:false, multiLine:true,maxFontSize:15, minFontSize:10});
            $('select').select2();
            var ttw=300;

            if(!side) {
                $('.career-path__career').each(function () {
                    var $this = $(this);
                    setTimeout(function () {
                        $this.addClass('init');
                    }, ttw);
                    ttw += 200;
                });
            }else{
                if(side=='both'){
                    $('.career-path__career.left, .career-path__career.right').each(function () {
                        var $this = $(this);
                        setTimeout(function () {
                            $this.addClass('init');
                        }, ttw);
                        ttw += 200;
                    });
                }else{
                    $('.career-path__career'+side).each(function () {
                        var $this = $(this);
                        setTimeout(function () {
                            $this.addClass('init');
                        }, ttw);
                        ttw += 200;
                    });
                }
            }
            $('.career-path__career').off('click');
            $('.career-path__career').on('click',function(e){
                if(e.target.id=='reset' || $(e.target).parent().attr('id')=='reset') return;
                var $career=$(this);
                if($career.hasClass('hidden')) return;
                var vals= {};
                if($career.attr('id')=='career'){
                    vals['which']='primary';
                }else{
                    vals['which']='related';
                }
                vals['occupation-id']=$career.data('occupation-id');
                vals['action']='fw_career_card_career_path_ajax';

                addWaiting();
                var eventVals={'url':'/wp-admin/admin-ajax.php', 'data':vals,'dataType':'html','action':'overlay','olclass':'careerpath'};
                $.ajax({
                    type:'POST',
                    url: '/wp-admin/admin-ajax.php',
                    data:vals,
                    dataType: 'html',
                    success: function(data)
                    {
                        addOverlay('careerpath',data);
                        addEvent(eventVals,'career-details');
                        $('#waiting').remove();
                    },
                    error: function(xhr, desc, err) {
                        console.log(xhr);
                        console.log("Details0: " + desc + "\nError:" + err);
                    },
                });
            });
            $(document).off('click','.see-path');
            $(document).on('click','.see-path',function(e){
                e.preventDefault();
                var destination=$(this).data('occupation-id');
                addWaiting();
                var vals={'url':'/wp-admin/admin-ajax.php','data':{action:'fw_lmi_get_career_path_ajax','start':$('#career').data('occupation-id'),'end':destination},'dataType':'json','destination':destination,'action':'showPath'};
                $.ajax({
                    type:'POST',
                    url: vals.url,
                    data: vals.data,
                    dataType: vals.dataType,
                    success: function(data)
                    {
                        console.log(data);
                        showPath(data,destination);
                        addEvent(vals,'show-path');

                        $(window).off('resize');
                        var resizeTimer;
                        $(window).on('resize',function(){
                            clearTimeout('resizeTimer');
                            resizeTimer=setTimeout(function(){
                              showPath(data,destination);
                            },100);
                        });
                    },
                    error: function(xhr, desc, err) {
                        console.log(xhr);
                        console.log("Details0: " + desc + "\nError:" + err);
                    },
                });
            });

            $('.filters__path-type').off('click');
            $('.filters__path-type').on('click',function(){
                var $this=$(this);
                if($this.closest('.filters__filter').hasClass('disabled')) return;
                $('.filters__path-type').removeClass('active');
                $this.addClass('active');
                if($this.hasClass('see-all')){
                    $('.career-path__career').removeClass('hidden-type');
                }else {
                    $('.career-path__career:not(#career)').addClass('hidden-type');
                    var $row=$('.' + $this.data('path-filter-row'));
                    var row='.' + $this.data('path-filter-row');
                    $row.removeClass('hidden-type');
                    if($this.data('path-center')){
                        if($this.data('path-center')=='center') $(row+'.right, '+row+'.left').addClass('hidden-type');
                    }else{
                        $(row+'.center').addClass('hidden-type');
                    }
                }
                $('#career').removeClass('hidden-type');
            });
            $('.filters__education select').off('change');
            $('.filters__education select').on('change', function(){
                if($(this).closest('.filters__filter').hasClass('disabled')) return;
                var val=$(this).find(':selected').val();
                var $careers=$('.career-path__career')
                if(val==='all'){
                    $careers.removeClass('hidden-edu');
                }else {
                    $careers.addClass('hidden-edu');
                    $('.career-path__career[data-education="' + val + '"]').removeClass('hidden-edu');
                    if(val.toLowerCase().includes('high school')){
                        $('.career-path__career[data-education="high school diploma"]').removeClass('hidden-edu');
                    }
                }
                $('#career').removeClass('hidden-edu');
            });
            $('.filters__path-type.active').click();
            $('.filters__education select').change();
        }
    }
    function showPath(data,destination){
        $('#waiting').remove();
        $('#overlay').remove();
        $('.path-selector').remove();
        $('.career-path__career:not(#career)').addClass('hidden');
        var $destination=$('#c'+destination);
        $destination.removeClass('hidden');
        $('#paths,#path-info').remove();
        $('body').append('<div id="paths"></div>');
        $('body').append('<div id="path-info"></div>');
        var pathID=1;
        var pathCt=0;
        if('direct' in data){
            pathID=2;
        }
        $('#career .path-selectors').remove();
        $('.filters').append('<div class="path-selectors"><div class="path-selectors__wrap"><p class="label"><small>Explore</small>Career Paths</p></div></div>');

        if('direct' in data){
            //drawPath($('#career'),$destination,1,1);
            var $careerS=$('.career-path__career[data-occupation-id="'+data.direct.StartCareerID +'"]');
            var $careerD=$('.career-path__career[data-occupation-id="'+data.direct.FinalDestinationID +'"]');
            drawPath($careerS,$careerD,1,1);
            if('paths' in data && Object.keys(data.paths).length>0) $('.path-selectors__wrap').append('<div class="path-selector active skiptranslate" data-path="1" style="order:-1;">1</div>');
            pathCt++;
        }
        console.log(data.paths);
        if (data && data.paths && typeof data.paths === 'object') {
            for (var key in data.paths) {
                if (pathCt >= 5) continue;
                var $careerA = $('#c' + key);
                if (!$careerA.length) continue;
                var $careerS = $('.career-path__career[data-occupation-id="' + data.paths[key].StartCareerID + '"]');
                var $careerD = $('.career-path__career[data-occupation-id="' + data.paths[key].FinalDestinationID + '"]');

                //if($career.hasClass('row2')) continue;
                //if($career.data('row')==$destination.data('row') && $career.data('column')==$destination.data('column')) continue;

                //$career.removeClass('hidden');
                $careerA.addClass('paths' + pathID);
                $careerS.addClass('paths' + pathID);
                $careerD.addClass('paths' + pathID);
                /*
                if($destination.hasClass('row2')){
                    drawPath($career, $('#career'), pathID);
                    drawPath($destination, $career, pathID);
                }else {
                    drawPath($('#career'), $career, pathID);
                    drawPath($career, $destination, pathID);
                }*/
                drawPath($careerS, $careerA, pathID);
                drawPath($careerA, $careerD, pathID);
                $('.path-selectors__wrap').append('<div class="path-selector skiptranslate" data-path="' + pathID + '">' + pathID + '</div>');
                pathID++;
                pathCt++;
            }
        }
        $destination.removeClass('hidden');
        if(pathCt<2){
            $('.path-selectors').remove();
        }
        $('.path-info__box').on('click',function(){
            addWaiting();
            var $info=$(this);
            var vals={'url':'/wp-admin/admin-ajax.php','data':{action:'fw_career_card_career_path_ajax','start':$info.data('start'),'end':$info.data('finish')},'dataType':'html','action':'overlay','olclass':'careerpath'};
            $.ajax({
                type:'POST',
                url: vals.url,
                data: vals.data,
                dataType: vals.dataType,
                success: function(data)
                {
                    addOverlay('careerpath',data);
                    addEvent(vals,'path-info');
                    $('#waiting').remove();
                },
                error: function(xhr, desc, err) {
                    console.log(xhr);
                    console.log("Details0: " + desc + "\nError:" + err);
                },
            });
        });
        $('.filters__filter ').addClass('disabled');
        $('select#education').prop('disabled',true);
        $('.career-path').on('click',function(e){
            var $target=$(e.target);
            if(!$target.hasClass('career_path__career') && !$target.hasClass('.path-info') && !$target.hasClass('hidden')){
                $('#paths,#path-info,.path-selector,.path-selectors').remove();
                $('.career-path__career').removeClass('hidden');
                $('.filters__filter ').removeClass('disabled');
                $('select#education').prop('disabled',false);
            }
        });
        $('.path-selector').on('click',function(e){
            e.stopPropagation();
            $('.paths, .path-info,.path-selector,.career-path__career:not(#career)').removeClass('active');
            $(this).addClass('active');
            $('.paths'+$(this).data('path')).addClass('active');
            $('.paths').find('line').attr('stroke-dasharray','10,5')
            $('.paths.active').find('line').attr('stroke-dasharray','0');
        });
        $('.path-selector').hover(function(){
            //$('.paths, .path-info,.path-selector').removeClass('active');
            $(this).addClass('hover');
            $('.paths'+$(this).data('path')).addClass('hover');
        },function(){
            $(this).removeClass('hover');
            $('.paths'+$(this).data('path')).removeClass('hover');
        });
    }
    function drawPath($start, $finish, pathID,pathCount=0){
        var active='';
        var dasharray='10, 5';
        if(pathCount===1){
            active=' active';
            dasharray='0';
        }

        var sw = 0,
            sh = 0,
            fw = 0,
            fh = 0,
            sx = 0,
            sy = 0,
            fx = 0,
            fy = 0,
            ix = 0,
            iy = 0;
        sh=$start.height();
        sw=$start.width();
        fh=$finish.height();
        fw=$finish.width();
        sx=$start.offset().left;
        sy=$start.offset().top;
        fx=$finish.offset().left;
        fy=$finish.offset().top;

        var x1=( sx + (sw/2) );
        var y1=( sy + (sh/2) );
        var x2=( fx + (fw/2) );
        var y2=( fy + (fh/2) );
        var colors=['red','blue','black','orange'];


        $('#paths').append('<svg class="paths paths'+pathID+active+'"><line x1="'+x1+'" y1="'+y1+'" x2="'+x2+'" y2="'+y2+'" stroke="white"  stroke-dasharray="'+dasharray+'" stroke-width="3"/></svg>');

        $('#path-info').append('<div class="path-info paths'+pathID+active+'" style="left:'+Math.min(x1,x2)+'px; top:'+Math.min(y1,y2)+'px; width:'+( Math.max(x1,x2) - Math.min(x1,x2) )+'px; height:'+(Math.max(y1,y2) - Math.min(y1,y2) )+'px;"><div class="path-info__box" data-start="'+$start.data('occupation-id')+'" data-finish="'+$finish.data('occupation-id')+'"><i class="fas fa-info"></i></div></div>');
    }


    window.addEventListener('popstate', event => {
        if(event.state!==null) {
            if(typeof event.state.initial !== 'undefined'){
                $('#overlay').remove();
                $('#waiting').remove();
                $('#waiting').remove();
                $('#overlay').remove();
                $('.path-selector').remove();
                $('.career-path__career').removeClass('hidden');
                $('#paths,#path-info').remove();
                return;
            }
            addWaiting();
            jQuery.ajax({
                type: 'POST',
                url: event.state.url,
                data: event.state.data,
                dataType: event.state.dataType,
                success: function (data) {
                    if(event.state.action==='overlay'){
                        addOverlay(event.state.olclass,data);
                    }else if(event.state.action==='showPath'){
                        showPath(data,event.state.destination);
                        $(window).off('resize');
                        var resizeTimer;
                        $(window).on('resize',function(){
                            clearTimeout('resizeTimer');
                            resizeTimer=setTimeout(function(){
                                showPath(data,event.state.destination);
                            },100);
                        });
                    }else if(event.state.selector!==null) {
                        if(event.state.action==='clearClusters'){
                            clearClusters(event.state.side);
                            $('#the-path').append(data);
                            setupCp(event.state.side);
                        }else {
                            jQuery(event.state.selector).html(data);
                            if (event.state.action === 'setupCp') {
                                setupCp();
                            } else {
                                console.log('unhandled popstate action');
                                console.log(event);
                                console.log(data);
                            }
                        }
                    }else {
                        console.log('unhandled popstate');
                        console.log(event);
                        console.log(data);
                    }
                    jQuery('#waiting').remove();
                },
                error: function (xhr, desc, err) {
                    console.log(xhr);
                    console.log("Details0: " + desc + "\nError:" + err);
                },
            });
        }else{
            //location.reload();
        }
    });
});

function addEvent(data=null,which) {
    if(window.history.pushState) {
        window.history.pushState(data, which, '#'+which);
    }else {
        location.hash = '#'+which;
    }
}
